import React from "react";
import "./Footer.css";
import {
  FaInstagram,
  FaLinkedin,
  FaFacebook,
  FaYoutube,
  FaTiktok,
  FaTwitter,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="footer-grid">
          {/* Column 1: Logo & giới thiệu */}
          <div className="footer-col">
            <h3 className="footer-logo">timquanhday</h3>
            <p className="footer-desc">
              timquanhday – Nền tảng tìm mọi thứ quanh bạn
            </p>
            <div className="app-buttons">
              <button className="app-btn" aria-label="App Store">
                App Store
              </button>
              <button className="app-btn" aria-label="Google Play">
                Google Play
              </button>
            </div>
          </div>

          {/* Column 2: Liên kết nhanh */}
          <div className="footer-col">
            <h4 className="footer-heading">Liên kết nhanh</h4>
            <ul className="footer-links">
              <li>
                <a href="/">Trang chủ</a>
              </li>
              <li>
                <a href="/hoat-dong">Hoạt động</a>
              </li>
              <li>
                <a href="/dien-dan">Diễn đàn</a>
              </li>
              <li>
                <a href="/tro-thanh-doi-tac">
                  Trở thành đối tác <span className="new-badge">New</span>
                </a>
              </li>
              <li>
                <a href="/dieu-khoan">Điều khoản dịch vụ</a>
              </li>
              <li>
                <a href="/ve-chung-toi">Về chúng tôi</a>
              </li>
            </ul>
          </div>

          {/* Column 3: Liên hệ (mạng xã hội) */}
          <div className="footer-col">
            <h4 className="footer-heading">Liên hệ</h4>
            <div className="social-row">
              <button className="social-icon" aria-label="Instagram">
                <FaInstagram />
              </button>
              <button className="social-icon" aria-label="LinkedIn">
                <FaLinkedin />
              </button>
              <button className="social-icon" aria-label="Facebook">
                <FaFacebook />
              </button>
              <button className="social-icon" aria-label="YouTube">
                <FaYoutube />
              </button>
              <button className="social-icon" aria-label="TikTok">
                <FaTiktok />
              </button>
              <button className="social-icon" aria-label="Twitter">
                <FaTwitter />
              </button>
            </div>
          </div>

          {/* Column 4: Thông tin */}
          <div className="footer-col">
            <h4 className="footer-heading">Thông tin</h4>
            <div className="contact-info">
              <p>
                <strong>Địa chỉ:</strong> Tầng 20, tòa A, đường B, Cầu Giấy, Hà
                Nội
              </p>
              <p>
                <strong>Số điện thoại:</strong> 0123 456 789
              </p>
              <p>
                <strong>Email:</strong>{" "}
                <a href="mailto:support@timquanhday.com">
                  support@timquanhday.com
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <p className="copyright">© 2025 timquanhday. All rights reserved.</p>
          <div className="bottom-social">
            <button className="bottom-icon" aria-label="Instagram">
              <FaInstagram />
            </button>
            <button className="bottom-icon" aria-label="LinkedIn">
              <FaLinkedin />
            </button>
            <button className="bottom-icon" aria-label="Facebook">
              <FaFacebook />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
